// import AccountsModel from '../models/accounts.model';

let storeContent = utils.generateStore({
	schools: [],
	students: [],
	selected_student_fee_structures: [],
	school_notifications: [],
	showSchool: false,
	showStudentFeeStructures: false,
	activeTab: 1,
	selected_school: null,
	selected_fee_structure: null,
	selected_student: null,
	school_details: null,
	show_process_fee_structure: null,
});

export default {
	state() {
		return { ...storeContent.state };
	},
	getters: {
		...storeContent.getters,
	},
	mutations: {
		...storeContent.mutations,
	},
	actions: {
		async fetchSchools(ctx) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'parent',
						action: 'schools',
						data: {
							// claim_id: payload.claim.claim_id,
						},
					},
					'/client',
				);

				if (
					res.result.parent_schools &&
					res.result.parent_schools.schools
				) {
					ctx.commit('schools', res.result.parent_schools.schools);
				}
			} catch (err) {
				throw err;
			}
		},
		async fetchStructure(ctx, fee_structure) {
			try {
				// let res = await api.fetchEndpointSecure(
				//    {
				//       resource: 'claim',
				//       action: 'details',
				//       data: {
				//          claim_id: payload.claim.claim_id,
				//       },
				//    },
				//    '/client'
				// );

				ctx.commit('selected_fee_structure', fee_structure);
				// ctx.commit('selected_fee_structure',fee_structure.fee_structure);
			} catch (err) {
				throw err;
			}
		},
		async fetchStudentFeeStructure(ctx, student) {
			try {
				ctx.commit('selected_student', student);
				console.log('Student: ', student);
				let res = await api.fetchEndpointSecure(
					{
						resource: 'feestructure',
						action: 'get',
						data: {
							grade_system_ref:
								student.class_details.grade_system_ref,
						},
					},
					'/client',
				);

				if (res.result.feestructure) {
					ctx.commit(
						'selected_student_fee_structures',
						res.result.feestructure,
					);
				}
			} catch (err) {
				throw err;
			}
		},
		async fetchStudentInvoices(ctx, student) {
			try {
				ctx.commit('selected_student', student);
				let res = await api.fetchEndpointSecure(
					{
						resource: 'school_invoice',
						action: 'student_invoices',
						data: {
							student_system_ref:
								student.student_details.student_system_ref,
						},
					},
					'/client',
				);

				if (res.result.fee_structure) {
					// ctx.commit('selected_student_fee_structures',res.result.fee_structure);
					console.log('Fee Structure Set.');
				}
			} catch (err) {
				throw err;
			}
		},
		async viewStudent(ctx, student) {
			try {
				Event.$emit('loader:show', true);
				await ctx.dispatch('fetchStudentFeeStructure', student);
				// await ctx.dispatch('fetchStudentInvoices', student)
				ctx.commit('show_process_fee_structure', true);
				// ctx.commit('showStudentFeeStructures',true)
				Event.$emit('loader:show', false);
			} catch (err) {
				Event.$emit('loader:show', false);
				throw err;
			}
		},
		async viewStudentFeeStructure(ctx, fee_structure) {
			try {
				Event.$emit('loader:show', true);
				await ctx.dispatch('fetchStructure', fee_structure);
				ctx.commit('showFeeStructure', true);
				Event.$emit('loader:show', false);
			} catch (err) {
				Event.$emit('loader:show', false);
				throw err;
			}
		},
		async fetchData(ctx) {
			try {
				Event.$emit('loader:show', true);
				await ctx.dispatch('fetchSchools');
				Event.$emit('loader:show', false);
			} catch (err) {
				Event.$emit('loader:show', false);
				throw err;
			}
		},
		async fetchSchoolsDetails(ctx) {
			try {
				// Fetch school details
				let res = await api.fetchEndpointSecure(
					{
						resource: 'school',
						action: 'details',
						data: {
							school_system_ref:
								ctx.getters.selected_school.school_system_ref,
						},
					},
					'/client',
				);
				ctx.commit(
					'school_notifications',
					res.result.school_notifications,
				);

				// Fetch parent school students
				res = await api.fetchEndpointSecure(
					{
						resource: 'parent_v2',
						action: 'school_students',
						data: {
							school_system_ref:
								ctx.getters.selected_school.school_system_ref,
						},
					},
					'/client',
				);

				if (res.result.parent_students) {
					ctx.commit('students', res.result.parent_students);
				}

				ctx.commit('school_details', {
					fee_structures: [
						{
							name: 'Fee Structure for Standard 7 Kenya',
							class: 'Standard 7',
							ref: 'ADFETYW832872993',
							status: 'initiated',
							applicable_period_from: '2021-06-01T18:59:30.712Z',
							applicable_period_to: '2021-07-30T18:59:30.712Z',
							total: 200000,
							currency: 'KES',
							terms: [
								{
									name: 'Term 1',
									from: '2021-02-01T18:59:30.712Z',
									to: '2021-04-28T18:59:30.712Z',
									mandatory: [
										{ name: 'Tuition Fee', cost: 52000 },
										{ name: 'Library Fee', cost: 500 },
										{ name: 'School Bus', cost: 2500 },
										{ name: 'Sports', cost: 8500 },
									],
									optional: [
										{
											name: 'Swimming',
											cost: 3000,
											min: 2000,
											max: 5000,
											is_selected: false,
										},
										{
											name: 'Music',
											cost: 4000,
											min: 4000,
											max: 7000,
											is_selected: false,
										},
										{
											name: 'School Trip',
											cost: 15000,
											min: 15000,
											max: 15000,
											is_selected: false,
										},
									],
								},
								{
									name: 'Term 2',
									from: '2021-05-09T18:59:30.712Z',
									to: '2021-08-14T18:59:30.712Z',
									mandatory: [
										{ name: 'Tuition', cost: 47000 },
										{ name: 'Library', cost: 500 },
										{ name: 'School Bus', cost: 2500 },
										{ name: 'Sports', cost: 6500 },
									],
									optional: [
										{
											name: 'Swimming',
											cost: 3000,
											min: 2000,
											max: 5000,
										},
										{
											name: 'Music',
											cost: 4000,
											min: 4000,
											max: 7000,
										},
										{
											name: 'School Trip',
											cost: 15000,
											min: 15000,
											max: 15000,
										},
									],
								},
								{
									name: 'Term 3',
									from: '2021-09-12T18:59:30.712Z',
									to: '2021-11-21T18:59:30.712Z',
									mandatory: [
										{ name: 'Tuition', cost: 32000 },
										{ name: 'Library', cost: 500 },
										{ name: 'School Bus', cost: 2500 },
										{ name: 'Sports', cost: 8500 },
									],
									optional: [
										{
											name: 'Swimming',
											cost: 3000,
											min: 2000,
											max: 5000,
										},
										{
											name: 'Music',
											cost: 4000,
											min: 4000,
											max: 7000,
										},
										{
											name: 'School Trip',
											cost: 15000,
											min: 15000,
											max: 15000,
										},
									],
								},
							],
						},
						{
							name: 'Fee Structure for Standard 7 Kenya',
							class: 'Standard 4',
							ref: 'ADFETYW832872993',
							status: 'processed',
							applicable_period_from: '2021-06-01T18:59:30.712Z',
							applicable_period_to: '2021-07-30T18:59:30.712Z',
							total: 125400,
							currency: 'KES',
							terms: [
								{
									name: 'Term 1',
									from: '2021-02-01T18:59:30.712Z',
									to: '2021-04-28T18:59:30.712Z',
									mandatory: [
										{ name: 'Tuition Fee', cost: 30000 },
										{ name: 'Library Fee', cost: 500 },
										{ name: 'School Bus', cost: 2500 },
										{ name: 'Sports', cost: 8500 },
									],
									optional: [
										{
											name: 'Swimming',
											cost: 3000,
											min: 2000,
											max: 5000,
										},
										{
											name: 'Music',
											cost: 4000,
											min: 4000,
											max: 7000,
										},
										{
											name: 'School Trip',
											cost: 15000,
											min: 15000,
											max: 15000,
										},
									],
								},
								{
									name: 'Term 2',
									from: '2021-05-09T18:59:30.712Z',
									to: '2021-08-14T18:59:30.712Z',
									mandatory: [
										{ name: 'Tuition', cost: 22000 },
										{ name: 'Library', cost: 500 },
										{ name: 'School Bus', cost: 2500 },
										{ name: 'Sports', cost: 8500 },
									],
									optional: [
										{
											name: 'Swimming',
											cost: 3000,
											min: 2000,
											max: 5000,
										},
										{
											name: 'Music',
											cost: 4000,
											min: 4000,
											max: 7000,
										},
										{
											name: 'School Trip',
											cost: 15000,
											min: 15000,
											max: 15000,
										},
									],
								},
								{
									name: 'Term 3',
									from: '2021-09-12T18:59:30.712Z',
									to: '2021-11-21T18:59:30.712Z',
									mandatory: [
										{ name: 'Tuition', cost: 18000 },
										{ name: 'Library', cost: 500 },
										{ name: 'School Bus', cost: 2500 },
										{ name: 'Sports', cost: 3500 },
									],
									optional: [
										{
											name: 'Swimming',
											cost: 3000,
											min: 2000,
											max: 5000,
										},
										{
											name: 'Music',
											cost: 4000,
											min: 4000,
											max: 7000,
										},
										{
											name: 'School Trip',
											cost: 15000,
											min: 15000,
											max: 15000,
										},
									],
								},
							],
						},
					],
				});
			} catch (err) {
				throw err;
			}
		},
		async processFeeStructure(ctx, fee_structure) {
			try {
				ctx.commit('loading', true);
				// let res = await api.fetchEndpointSecure(
				//    {
				//       resource: 'claim',
				//       action: 'details',
				//       data: {
				//          claim_id: payload.claim.claim_id,
				//       },
				//    },
				//    '/client'
				// );

				ctx.commit('selected_fee_structure', fee_structure);
				ctx.commit('show_process_fee_structure', true);
				ctx.commit('loading', false);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		async generateInvoice(ctx, { router, fee_structure, all_total }) {
			try {
				Event.$emit('loader:show', true);
				let term_items = [];

				if (all_total <= 0) {
					$notify(
						'warning',
						'Invoice Generation Failed',
						`Total fees provided cannot be zero.`,
						5,
					);
					Event.$emit('loader:show', false);
					return null;
				}
				for (let i = 0; i < fee_structure.length; i++) {
					const term = fee_structure[i];
					// let items = [];

					if (term.is_selected) {
						for (
							let j = 0;
							j < term.term_fees.mandatory.length;
							j++
						) {
							const fee = term.term_fees.mandatory[j];

							term_items.push({
								// academic_year_id: term?.term?.academic_year_details?.academic_external_id,
								academic_term_id: term.term.term_external_id,
								fee_item_id: fee.fee_item_id,
								fee_item_name: fee.fee_item_name,
								is_optional: fee.is_optional,
								amount: Number(fee.amount),
							});
						}

						for (
							let j = 0;
							j < term.term_fees.optional.length;
							j++
						) {
							const fee = term.term_fees.optional[j];

							if (fee.is_selected) {
								term_items.push({
									// academic_year_id: term?.term?.academic_year_details?.academic_external_id,
									academic_term_id:
										term.term.term_external_id,
									fee_item_id: fee.fee_item_id,
									is_optional: fee.is_optional,
									amount: Number(fee.amount),
								});
							}
						}

						// term_items.push({term_system_ref: term.term.term_system_ref,term_fees: items})
					}
				}

				let res = await api.fetchEndpointSecure(
					{
						resource: 'feestructure',
						action: 'invoice_financing',
						data: {
							student_system_ref:
								ctx.getters.selected_student.student_details
									.student_system_ref,
							grade_system_ref:
								ctx.getters.selected_student.class_details
									.grade_system_ref,
							fee_items: term_items,
						},
					},
					'/client',
				);

				if (res.result) {
					$notify(
						'success',
						'Invoice Generated',
						`Fees Invoice successfully generated, total amount: <b>${all_total}</b>.`,
						10,
					);
					ctx.commit('show_process_fee_structure', false);
					ctx.commit('showSchool', false);
					router.push({ name: 'School_Fees_Invoice' });
				} else {
					$notify(
						'error',
						'Invoice Generation Failed',
						`Fees Invoice not generated.`,
						5,
					);
				}

				Event.$emit('loader:show', false);
			} catch (err) {
				Event.$emit('loader:show', false);
				throw err;
			}
		},
		openTab(ctx, page) {
			ctx.commit('activeTab', page);
		},
		async viewSchool(ctx, school) {
			try {
				Event.$emit('loader:show', true);
				ctx.commit('selected_school', school);
				await ctx.dispatch('fetchSchoolsDetails');
				ctx.commit('showSchool', true);
				Event.$emit('loader:show', false);
			} catch (err) {
				Event.$emit('loader:show', false);
				throw err;
			}
		},
	},
};
